import Vue from "vue/dist/vue.esm";
import SelectDropdown from "components/select-dropdown";

const $dropdownContainers = document.querySelectorAll(".js-select-dropdown");

if($dropdownContainers.length > 0) {
  $dropdownContainers.forEach($container => {
    const {
      inputValue,
      hiddenInputField,
      windowStateKey
    } = $container.dataset;

    const options = JSON.parse($container.dataset.options);

    new Vue({
      el: $container,
      render: h => h(SelectDropdown, {
        props: {
          inputValue,
          hiddenInputField,
          windowStateKey,
          inputOptions: options
        }
      })
    });
  })
}
